import React from "react";
import "../Evaluation.css";
import Acadamic from "../../../assest/academic_observation.png";
import Behaviour from "../../../assest/behaviour_observation.png";
import { useNavigate, useParams } from "react-router-dom";

const Header = ({
  Childlist,
  Language_list,
  Language_option,
  setLanguage_option,
}) => {
  const { school_id, id, type, child_id, qtype } = useParams();
  const Navigate = useNavigate();
  const BackHandler = () => {
    Navigate(
      `/classdetail/${school_id}/${type == "other" ? btoa("other") : id}`
    );
  };
  const Child_Handler = (childid) => {
    Navigate(`/evaluation/${school_id}/${id}/${type}/${childid}/1`);
  };
  return (
    <div className="hidden w-full  max-[740px]:block max-[740px]:mt-10 max-[540px]:mt-3">
      <button
        title="Back"
        onClick={BackHandler}
        className="text-3xl m-3 text-[black] flex items-center"
      >
        {" "}
        <i class="fa-solid fa-arrow-left-long"></i>
        <span className="text-[18px] ml-2">Back</span>
      </button>
      <div className="flex px-2 py-2 bg-[#0001]">
        {/* SELECT CHILD START*/}
        <div className="w-6/12 border-r-2 border-solid border-[#0002] px-2">
          <div>
            {Childlist?.map((item, index) => {
              if (item.child_view_id == atob(child_id)) {
                return (
                  <div key={index} className="flex items-center my-2">
                    <p className="mr-3 text-3xl text-[#0005]">
                      <i className="fa-solid fa-user"></i>
                    </p>
                    <div>
                      <p className="font-semibold text-md">
                        {item?.child_name}
                      </p>
                      <p className="text-sm font-medium text-[#0009]">
                        {item?.child_standard}
                      </p>
                    </div>
                  </div>
                );
              }
            })}
          </div>
          <div className="w-full flex flex-col">
            {/* <label
              htmlFor=""
              className="font-semibold mb-1 text-[#000] text-lg"
            >
              Select child
            </label> */}
            <select
              name=""
              id=""
              className="text-[black] font-semibold rounded bg-[#cccc]"
              value={atob(child_id)}
              onChange={Child_Handler}
            >
              {Childlist?.map((item, index) => {
                return (
                  <option key={index} value={item?.child_view_id}>
                    {item?.child_name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
        {/* SELECT CHILD END*/}

        {/* LANGUAGE SELECT START */}
        <div className="w-6/12 border-l-2 border-solid border-[#0002] px-2 flex flex-col justify-end">
          <label htmlFor="" className="font-semibold mb-2">
            Language
          </label>
          <select
            name=""
            id=""
            value={Language_option}
            className="text-[black] font-semibold rounded bg-[#cccc]"
            onChange={(e) => setLanguage_option(e.target.value)}
          >
            {Language_list?.map((item, index) => {
              return (
                <option key={index} value={item?.id}>
                  {item?.language_name}
                </option>
              );
            })}
          </select>
        </div>
        {/* LANGUAGE SELECT END */}
      </div>

      {/* PROGRESS START */}
      <div className="w-10/12 mx-auto my-5">
        <div className="w-full flex items-center justify-center">
          <div className="flex items-center justify-center">
            <div className="w-12 bg-[#f8dbc0] flex items-center justify-center p-2 rounded-full border-2 border-[#f79221] relative">
              <img src={Acadamic} className="w-full" alt="" />
              <p className="absolute text-xs w-40 top-[115%] pt-1 font-semibold text-center">
                Academic Observation
              </p>
            </div>
          </div>
          <div className="w-6/12 h-2 bg-[#f8dbc0]">
            <span
              className={`h-full w-${
                qtype == 1 ? "6" : "12"
              }/12 bg-[#f79221] block`}
            ></span>
          </div>
          <div className="flex items-center justify-center">
            <div
              className={`w-12  flex items-center justify-center p-2 rounded-full border-2 ${
                qtype == 1
                  ? "border-[#757575] bg-[#f4f4f4] grayscale"
                  : "border-[#f79221] bg-[#f8dbc0]"
              }  relative`}
            >
              <img src={Behaviour} className="w-full" alt="" />
              <p className="absolute text-xs w-40 top-[115%] pt-1 font-semibold text-center">
                Behaviour Observation
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* PROGRESS END */}
    </div>
  );
};

export default Header;
